import SignLogo from '../../../../../images/sign-logo.svg';
import styles from './loginActionTitle.module.scss';

interface ISignActionTitleProps {
  className: string;
}

function LoginActionTitle({ className }: ISignActionTitleProps) {
  return (
    <div className={className}>
      <div className={styles.signActionTitle}>
        <img src={SignLogo} className={styles.logo} />
        <div className={styles.titles}>
          <h2 className={styles.title}>Créer un compte</h2>
          <p className={styles.subtitle}>
            Votre compte est déjà activé, vous êtes au bon endroit...
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginActionTitle;
